module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_3_1-8ec3f2ae9ad1488e9a5091bf653d3625.png";